import React from 'react';
import { ChevronRight, Lock, Zap, Shield, CreditCard, ShieldCheck, Sparkles } from 'lucide-react';
interface BuyBarProps {
  onBuyClick: () => void;
}
function GoldenParticles() {
  const particles = Array.from({
    length: 6
  });
  return <div className="absolute inset-0 overflow-hidden pointer-events-none z-[1]" data-id="element-331">
      {particles.map((_, i) => {
      const left = `${Math.random() * 100}%`;
      const delay = `${Math.random() * 5}s`;
      const duration = `${10 + Math.random() * 5}s`;
      const displayClass = i >= 3 ? 'hidden sm:block' : 'block';
      return <div key={i} className={`absolute bottom-0 w-1 h-1 rounded-full bg-gold/60 ${displayClass}`} style={{
        left,
        animation: `particleFloat ${duration} linear ${delay} infinite`
      }} data-id="element-332" />;
    })}
    </div>;
}
export function BuyBar({
  onBuyClick
}: BuyBarProps) {
  return <div className="w-full" data-id="element-333">
      <style dangerouslySetInnerHTML={{
      __html: `
        @keyframes sweepRightToLeft {
          0% { transform: translateX(200%); }
          100% { transform: translateX(-200%); }
        }
      `
    }} data-id="element-334" />
      {/* Intro Text */}
      <div className="text-center mb-10 sm:mb-14 relative" data-id="element-335">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-xl h-full bg-[radial-gradient(ellipse_at_center,rgba(212,175,55,0.1),transparent_60%)] pointer-events-none blur-2xl" data-id="element-336" />
        <p className="font-serif text-3xl sm:text-5xl font-black text-white mb-4 leading-tight relative z-10 drop-shadow-[0_0_20px_rgba(212,175,55,0.15)]" data-id="element-337">
          La mayoría nunca cambia…
        </p>
        <p className="text-lg sm:text-2xl text-white/70 font-medium relative z-10" data-id="element-338">
          porque nunca pasa a la acción.
        </p>
      </div>

      <div className="relative bg-gradient-to-b from-[#111115] to-[#0A0A0B] border-2 rounded-2xl sm:rounded-[2rem] p-8 sm:p-14 shadow-[0_20px_80px_rgba(0,0,0,0.9),0_0_80px_rgba(212,175,55,0.25)] text-center overflow-hidden group" data-id="element-339">
        {/* Animated border glow */}
        <div className="absolute inset-0 rounded-2xl sm:rounded-[2rem] pointer-events-none sm:animate-shimmer" style={{
        background: 'linear-gradient(90deg, transparent, rgba(212,175,55,0.5), transparent)',
        backgroundSize: '200% 100%'
      }} data-id="element-340" />

        {/* Golden Light Sweep Effect (Right to Left) */}
        <div className="absolute inset-0 pointer-events-none z-[2] opacity-40" style={{
        background: 'linear-gradient(90deg, transparent, rgba(212,175,55,0.8), transparent)',
        width: '50%',
        animation: 'sweepRightToLeft 4s ease-in-out infinite'
      }} data-id="element-341" />

        {/* Golden particles */}
        <GoldenParticles data-id="element-342" />

        {/* Stronger background glow */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-lg h-full bg-[radial-gradient(ellipse_at_top,rgba(212,175,55,0.2),transparent_70%)] pointer-events-none transition-opacity duration-700 group-hover:opacity-100 opacity-80" data-id="element-343" />
        <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full max-w-sm h-1/2 bg-[radial-gradient(ellipse_at_bottom,rgba(212,175,55,0.12),transparent_70%)] pointer-events-none" data-id="element-344" />

        <div className="relative z-10" data-id="element-345">
          {/* Title with icon */}
          <div className="flex items-center justify-center gap-3 mb-3" data-id="element-346">
            <Sparkles className="w-6 h-6 sm:w-7 sm:h-7 text-gold" style={{
            animation: 'pulseGlow 2s ease-in-out infinite'
          }} data-id="element-347" />
            <h2 className="font-serif text-2xl sm:text-4xl font-black text-white drop-shadow-md" data-id="element-348">
              Activa tu acceso hoy
            </h2>
            <Sparkles className="w-6 h-6 sm:w-7 sm:h-7 text-gold" style={{
            animation: 'pulseGlow 2s ease-in-out infinite'
          }} data-id="element-349" />
          </div>

          {/* Subtitle */}
          <p className="text-white/60 text-sm sm:text-base font-medium mb-8 max-w-md mx-auto" data-id="element-350">
            No necesitas creer en esto.
            <br data-id="element-351" />
            Solo necesitas probarlo.
          </p>

          {/* Price with golden ring */}
          <div className="mb-8 relative inline-block" data-id="element-352">
            <div className="absolute inset-0 -m-8 rounded-full bg-[radial-gradient(circle,rgba(212,175,55,0.15),transparent_70%)] blur-2xl" style={{
            animation: 'pulseGlow 3s ease-in-out infinite'
          }} data-id="element-353" />
            <div className="text-6xl sm:text-7xl font-black text-white drop-shadow-[0_0_30px_rgba(212,175,55,0.5)] relative" style={{
            animation: 'pulseGlow 4s ease-in-out infinite'
          }} data-id="element-354">
              $14.39
            </div>
          </div>

          {/* Benefits with icons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-6 text-white/70 text-xs sm:text-sm font-medium mb-4" data-id="element-355">
            <span className="flex items-center gap-2" data-id="element-356">
              <Zap className="w-4 h-4 text-gold" data-id="element-357" />
              Acceso inmediato
            </span>
            <span className="hidden sm:inline text-white/20" data-id="element-358">·</span>
            <span className="flex items-center gap-2" data-id="element-359">
              <Shield className="w-4 h-4 text-gold" data-id="element-360" />
              Sin suscripciones
            </span>
            <span className="hidden sm:inline text-white/20" data-id="element-361">·</span>
            <span className="flex items-center gap-2" data-id="element-362">
              <CreditCard className="w-4 h-4 text-gold" data-id="element-363" />
              Pago único
            </span>
          </div>

          {/* Ready text */}
          <p className="text-gold/90 text-sm sm:text-base font-bold mb-10 flex items-center justify-center gap-2" data-id="element-364">
            <Sparkles className="w-4 h-4" data-id="element-365" />
            Estás a un paso de empezar algo diferente.
          </p>

          {/* CTA */}
          <div className="flex flex-col items-center justify-center" data-id="element-366">
            <button onClick={() => {
            onBuyClick();
          }} className="w-full sm:w-auto min-h-[56px] px-10 sm:px-16 py-5 sm:py-6 bg-gradient-to-r from-gold via-yellow-400 to-gold text-dark font-black text-base sm:text-lg rounded-xl shadow-[0_15px_40px_rgba(212,175,55,0.5)] flex items-center justify-center gap-2 uppercase tracking-wider hover:shadow-[0_25px_60px_rgba(212,175,55,0.7)] hover:scale-[1.02] active:scale-[0.98] transition-all duration-300 max-w-lg mx-auto mb-6 relative overflow-hidden group/btn" data-id="element-367">
              <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/40 to-transparent -translate-x-full animate-shimmer" data-id="element-368" />
              <span className="relative z-10 flex items-center gap-2" data-id="element-369">
                QUIERO ACTIVAR MI ACCESO
                <ChevronRight className="w-5 h-5" data-id="element-370" />
              </span>
            </button>

            {/* Payment methods */}
            <div className="flex items-center justify-center gap-3 mb-6 text-white/50 text-xs sm:text-sm" data-id="element-371">
              <CreditCard className="w-4 h-4" data-id="element-372" />
              <span data-id="element-373">Tarjeta</span>
              <span className="text-white/20" data-id="element-374">·</span>
              <svg className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor" data-id="element-375">
                <path d="M7.076 21.337H2.47a.641.641 0 0 1-.633-.74L4.944.901C5.026.382 5.474 0 5.998 0h7.46c2.57 0 4.578.543 5.69 1.81 1.01 1.15 1.304 2.42 1.012 4.287-.023.143-.047.288-.077.437-.983 5.05-4.349 6.797-8.647 6.797h-2.19c-.524 0-.968.382-1.05.9l-1.12 7.106zm14.146-14.42a3.35 3.35 0 0 0-.607-.541c-.013.076-.026.175-.041.254-.93 4.778-4.005 7.201-9.138 7.201h-2.19a.563.563 0 0 0-.556.479l-1.187 7.527h-.506l-.24 1.516a.56.56 0 0 0 .554.647h3.882c.46 0 .85-.334.922-.788.06-.26.76-4.852.76-4.852a.932.932 0 0 1 .924-.788h.58c3.76 0 6.705-1.528 7.565-5.946.36-1.847.174-3.388-.762-4.46z" data-id="element-376" />
              </svg>
              <span data-id="element-377">PayPal</span>
              <span className="text-white/20" data-id="element-378">·</span>
              <Lock className="w-3.5 h-3.5" data-id="element-379" />
              <span data-id="element-380">Pago seguro</span>
            </div>

            {/* 30-day guarantee */}
            <div className="bg-white/5 border border-gold/20 rounded-xl px-4 py-3 mb-6 max-w-md mx-auto" data-id="element-381">
              <div className="flex items-start gap-3" data-id="element-382">
                <ShieldCheck className="w-5 h-5 text-gold shrink-0 mt-0.5" data-id="element-383" />
                <div className="text-left" data-id="element-384">
                  <p className="text-white/90 text-xs sm:text-sm font-bold mb-1" data-id="element-385">
                    Garantía de 30 días
                  </p>
                  <p className="text-white/60 text-[10px] sm:text-xs leading-relaxed" data-id="element-386">
                    Si no es para ti, te devolvemos tu dinero.
                  </p>
                </div>
              </div>
            </div>

            {/* Emotional microcopy */}
            <div className="text-white/50 text-[11px] sm:text-xs font-medium mb-4 max-w-xs mx-auto leading-relaxed space-y-1" data-id="element-387">
              <p data-id="element-388">Puedes seguir igual… o empezar hoy.</p>
              <p className="text-white/70 font-bold" data-id="element-389">
                Esto no es información. Es el inicio del cambio.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>;
}